import { useRoutes } from "hookrouter";
import React from "react";
import CompleteSetup from "routes/completeSetup/CompleteSetp";
import Login from "routes/login/Login";
import CompleteReset from "routes/completeReset/CompleteReset";

const routes = {
    '/': () => <Login />,
    '/setup': () => <CompleteSetup />,
    '/reset': () => <CompleteReset />,
};


const App: React.FC = () => {
    const routeResult = useRoutes(routes);

    const isQa = () => {
        return window.location.hostname.includes('qa.') ||
            window.location.hostname.includes('localhost');
    }

    return (
        <div className="App">

            <div className="container-fluid">

                <div className="row">
                    <div className={`col-sm-6 trm-bg ${isQa() ? "qa" : ""}`}>
                        <div className="decor"></div>
                        <img src="images/trm-logo.svg" alt="TRM Logo" />
                    </div>
                    {routeResult}
                </div>
            </div>
        </div>
    );
}

export default App;